import axios from "axios";
import { endpoints } from "../utils/endpoints";

export const getBatteryIds = async (driverId) => {
  const { data } = await axios.get(
    `${endpoints.battery.ids}?driverId=${driverId}`
  );
  return data.data;
};
